gsap.registerPlugin(ScrollTrigger);
const bodys = gsap.utils.toArray('body');

let mm = gsap.matchMedia();

mm.add("(min-width: 992px)", () => {
  //Scrolling Cards
  let horizontalSection = document.querySelector('.banner-slider-ele');
  
  gsap.to('.banner-slider-ele', {
    x: () => horizontalSection.scrollWidth * -1,
    xPercent: 100,
    scrollTrigger: {
      trigger: '.banner-slider-ele',
      start: 'center center',
      end: '+=2000px top',
      pin: '.banner-slider-main',
      scrub: true,
      invalidateOnRefresh: true
    }
  });
});

bodys.forEach((body) => {
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.text-info-with-image',
      start:"top 60%",
      end:"top 80%",
      onEnter() {
        body.classList.add('dark-bg');
      },
      onEnterBack() {
        body.classList.remove('dark-bg');
      }
    }
  });
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.text-info-with-logo',
      start:"top 50%",
      end:"top 70%",
      onEnter() {
        body.classList.remove('dark-bg');
      },
      onEnterBack() {
        body.classList.add('dark-bg');
      }
    }
  });
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.full-width-video-section',
      start:"top 10%",
      end:"10% bottom",
      onEnter() {
        body.classList.add('video-zoom');
      },
      onEnterBack() {
        body.classList.remove('video-zoom');
      }
    }
  });
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.product-info-tabs',
      start:"top 60%",
      end:"top 60%",
      onEnter() {
        body.classList.add('dark-bg');
      },
      onEnterBack() {
        body.classList.remove('dark-bg');
      }
    }
  });
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.collapsible-section',
      start:"top 60%",
      end:"top 60%",
      onEnter() {
        body.classList.add('dark-bg');
      },
      onEnterBack() {
        body.classList.remove('dark-bg');
      }
    }
  });
});